import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TicketFlag, DeliveryParameters, TicketActionType, TicketService, ErrorStateService, TicketTransactionType, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import * as _moment from 'moment';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { GameBannerModule } from '@fgb/portal-component-library/src/lib/tickettransfer/game-banner';
import { SelectedTicketsTableModule } from '@fgb/portal-component-library/src/lib/tickettransfer/selected-tickets-table';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { HttpClient } from '@angular/common/http';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc2 from '@fgb/core';
import * as ɵngcc3 from '@angular/router';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/tickettransfer/game-banner';
import * as ɵngcc6 from '@fgb/portal-component-library/src/lib/tickettransfer/selected-tickets-table';
import * as ɵngcc7 from '@fgb/portal-component-library/src/lib/shared/errors';
import * as ɵngcc8 from '@fgb/portal-component-library/src/lib/shared/loading';
import * as ɵngcc9 from '@ngx-translate/core';

function TicketListItemComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵelementStart(1, "input", 23);
    ɵngcc0.ɵɵlistener("change", function TicketListItemComponent_div_2_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.toggleSelectTicket(ctx_r12.ticket.Id); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 24);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("checked", ctx_r0.ticket.selected);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 2, "cl.ticket.list.item.select.ticket"));
} }
function TicketListItemComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵlistener("click", function TicketListItemComponent_div_3_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); const _r10 = ɵngcc0.ɵɵreference(40); return ctx_r14.open(_r10); });
    ɵngcc0.ɵɵelement(1, "div", 26);
    ɵngcc0.ɵɵelementStart(2, "div", 27);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 1, "cl.ticket.list.item.call.back"));
} }
function TicketListItemComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 28);
    ɵngcc0.ɵɵelement(1, "div", 29);
    ɵngcc0.ɵɵelementEnd();
} }
function TicketListItemComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 30);
    ɵngcc0.ɵɵelement(1, "div", 31);
    ɵngcc0.ɵɵelementStart(2, "div", 27);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 1, "cl.ticket.list.item.transferred"));
} }
function TicketListItemComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, "cl.ticket.list.item.card.no"), ":");
} }
function TicketListItemComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, "cl.ticket.list.item.ticket.no"), ":");
} }
function TicketListItemComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "p", 32);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementStart(4, "span", 33);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 3, "cl.ticket.list.item.status"), ":");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2(" ", ɵngcc0.ɵɵpipeBind1(6, 5, "cl.ticket.list.item.transferred.to"), " - ", ctx_r6.ticket.TransfereeEmailAddress, " ");
} }
function TicketListItemComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "p", 34);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementStart(4, "span", 35);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 2, "cl.ticket.list.item.status"), ": ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 4, "cl.ticket.list.item.available"));
} }
function TicketListItemComponent_ng_template_37_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 36);
    ɵngcc0.ɵɵelementStart(1, "h4", 37);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 38);
    ɵngcc0.ɵɵlistener("click", function TicketListItemComponent_ng_template_37_Template_button_click_4_listener() { const modal_r16 = ctx.$implicit; return modal_r16.dismiss("Cross click"); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 39);
    ɵngcc0.ɵɵelement(6, "fgbcl-ticket-transfer-log", 40);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "cl.ticket.log.modal.title"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ticket", ctx_r9.ticket);
} }
function TicketListItemComponent_ng_template_39_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "cl.ticket.transfer.callback.confirm.button"));
} }
function TicketListItemComponent_ng_template_39_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelement(1, "fgbcl-loading", 45);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("size", "small");
} }
function TicketListItemComponent_ng_template_39_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelement(0, "fgbcl-game-banner");
    ɵngcc0.ɵɵelementStart(1, "div", 39);
    ɵngcc0.ɵɵelementStart(2, "div", 41);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "fgbcl-selected-tickets-table", 40);
    ɵngcc0.ɵɵelement(6, "fgbcl-errors");
    ɵngcc0.ɵɵelementStart(7, "div", 42);
    ɵngcc0.ɵɵelementStart(8, "button", 43);
    ɵngcc0.ɵɵlistener("click", function TicketListItemComponent_ng_template_39_Template_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.callbackTicket(); });
    ɵngcc0.ɵɵtemplate(9, TicketListItemComponent_ng_template_39_span_9_Template, 3, 3, "span", 10);
    ɵngcc0.ɵɵtemplate(10, TicketListItemComponent_ng_template_39_span_10_Template, 2, 1, "span", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "button", 44);
    ɵngcc0.ɵɵlistener("click", function TicketListItemComponent_ng_template_39_Template_button_click_11_listener() { const modal_r18 = ctx.$implicit; return modal_r18.dismiss("Cross click"); });
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵpipe(13, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 7, "cl.ticket.transfer.callback.text"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ticket", ctx_r11.ticket);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r11.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r11.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r11.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(13, 9, "cl.ticket.transfer.callback.cancel.button"), " ");
} }
function TicketTransferLogComponent_ng_container_29_ng_container_1_tr_15_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "td");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "td", 2);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const log_r7 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(log_r7.EmailAddress);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 3, log_r7.ATTENDANCE));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 5, "cl.ticket.transfer.log.attended"));
} }
function TicketTransferLogComponent_ng_container_29_ng_container_1_tr_15_ng_template_2_td_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const log_r7 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("", log_r7.FullName, " (", log_r7.EmailAddress, ")");
} }
function TicketTransferLogComponent_ng_container_29_ng_container_1_tr_15_ng_template_2_td_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const log_r7 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("", log_r7.TransfereeFullName, " (", log_r7.TransfereeEmailAddress, ")");
} }
function TicketTransferLogComponent_ng_container_29_ng_container_1_tr_15_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 13);
    ɵngcc0.ɵɵtemplate(1, TicketTransferLogComponent_ng_container_29_ng_container_1_tr_15_ng_template_2_td_1_Template, 2, 2, "td", 14);
    ɵngcc0.ɵɵtemplate(2, TicketTransferLogComponent_ng_container_29_ng_container_1_tr_15_ng_template_2_td_2_Template, 2, 2, "td", 15);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementStart(3, "td");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "td");
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const log_r7 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngSwitch", log_r7.TransactionTypeId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", 14);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(5, 4, log_r7.Date, "d MMM y | h:mm a"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r10.ticketTransactionType[log_r7.TransactionTypeId]);
} }
function TicketTransferLogComponent_ng_container_29_ng_container_1_tr_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr", 11);
    ɵngcc0.ɵɵtemplate(1, TicketTransferLogComponent_ng_container_29_ng_container_1_tr_15_ng_container_1_Template, 9, 7, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(2, TicketTransferLogComponent_ng_container_29_ng_container_1_tr_15_ng_template_2_Template, 8, 7, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const log_r7 = ctx.$implicit;
    const _r9 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", log_r7.ATTENDANCE)("ngIfElse", _r9);
} }
function TicketTransferLogComponent_ng_container_29_ng_container_1_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵelementStart(2, "div", 17);
    ɵngcc0.ɵɵelementStart(3, "span", 18);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "p");
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 19);
    ɵngcc0.ɵɵelementStart(9, "span", 18);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "p");
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵpipe(14, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 20);
    ɵngcc0.ɵɵelementStart(16, "span", 18);
    ɵngcc0.ɵɵtext(17);
    ɵngcc0.ɵɵpipe(18, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "p");
    ɵngcc0.ɵɵtext(20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const log_r17 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 7, "cl.mobile.ticket.transfer.log.recipient"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2("", log_r17.FullName, " (", log_r17.EmailAddress, ")");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 9, "cl.mobile.ticket.transfer.log.date.and.time"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(14, 11, log_r17.Date, "d MMM y - h:mm a"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(18, 14, "cl.mobile.ticket.transfer.log.status"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.ticketTransactionType[log_r17.TransactionTypeId]);
} }
function TicketTransferLogComponent_ng_container_29_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "table", 7);
    ɵngcc0.ɵɵelementStart(3, "thead");
    ɵngcc0.ɵɵelementStart(4, "tr");
    ɵngcc0.ɵɵelementStart(5, "th", 8);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "th", 8);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "th", 8);
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵpipe(13, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "tbody");
    ɵngcc0.ɵɵtemplate(15, TicketTransferLogComponent_ng_container_29_ng_container_1_tr_15_Template, 4, 2, "tr", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(16, TicketTransferLogComponent_ng_container_29_ng_container_1_ng_container_16_Template, 21, 16, "ng-container", 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ticketLog_r3 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 5, "cl.ticket.transfer.log.recipient"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(10, 7, "cl.ticket.transfer.log.date.and.time"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(13, 9, "cl.ticket.transfer.log.status"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ticketLog_r3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ticketLog_r3);
} }
function TicketTransferLogComponent_ng_container_29_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TicketTransferLogComponent_ng_container_29_ng_container_1_Template, 17, 11, "ng-container", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ticketLog_r3 = ctx.ngIf;
    ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(32);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ticketLog_r3.length > 0)("ngIfElse", _r1);
} }
function TicketTransferLogComponent_ng_template_31_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵtext(1, "No Items Found");
    ɵngcc0.ɵɵelementEnd();
} }
class TicketListItemComponent {
    constructor(modalService, ticketService, router, errorStateService) {
        this.modalService = modalService;
        this.ticketService = ticketService;
        this.router = router;
        this.errorStateService = errorStateService;
        this.ticketFlag = TicketFlag;
        this.subscription = new Subscription();
    }
    ngOnInit() { }
    checkFlag(status, flag) {
        // tslint:disable-next-line: no-bitwise
        return status & flag;
    }
    open(content) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
    }
    toggleSelectTicket(id) {
        this.ticketService.toggleSelectTicket(id);
    }
    callbackTicket() {
        this.loading = true;
        let deliveryParameters = new DeliveryParameters();
        deliveryParameters.TicketAction = TicketActionType.Callback;
        this.subscription = this.ticketService.callbackTicket(this.ticket, deliveryParameters).subscribe((result) => {
            if (result && result.length > 0) {
                if (result[0].Result.ErrorNumber === 0) {
                    this.modalService.dismissAll();
                    this.router.navigate(['TicketTransfer/tickets/:' + this.ticket.GameNumber]);
                }
                else {
                    this.errorStateService.addError(`Error: Callback failed. Description: ${result[0].Result.ErrorDescription}`);
                    setTimeout(() => {
                        this.errorStateService.clearErrors();
                        this.loading = false;
                    }, 3000);
                }
            }
            else {
                this.errorStateService.addError(`Error: Callback failed.`);
                setTimeout(() => {
                    this.errorStateService.clearErrors();
                    this.loading = false;
                }, 3000);
            }
        });
    }
}
TicketListItemComponent.ɵfac = function TicketListItemComponent_Factory(t) { return new (t || TicketListItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgbModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.TicketService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ErrorStateService)); };
TicketListItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TicketListItemComponent, selectors: [["fgbcl-ticket-list-item"]], inputs: { ticket: "ticket", transferWindowExists: "transferWindowExists", transferWindowOpen: "transferWindowOpen" }, decls: 41, vars: 28, consts: [[1, "card", "mb-4"], [1, "row"], ["class", "col-3 col-lg-2 text-center", 4, "ngIf"], ["class", "col-3 col-lg-2 text-center bg-dark call-back-button", 3, "click", 4, "ngIf"], ["class", "col-3 col-lg-2 text-center bg-primary d-flex justify-content-center align-items-center", 4, "ngIf"], ["class", "col-3 col-lg-2 text-center bg-primary", 4, "ngIf"], [1, "col-9", "col-lg-7"], [1, "ticket-list-item"], [1, "col-lg-4", "col-12", "card-number-div"], [1, "ticket-status", "font-weight-bold", "justify-content-around"], [4, "ngIf"], [1, "text-primary", "ml-1"], [1, "d-none", "d-lg-block", "ticket-area", "mb-0", "text-info"], [1, "col-lg-8", "col-12", "justify-content-around", "status-div"], [1, "pl-0", "col-8", "col-lg-12"], [1, "seat-details", "d-flex", "justify-content-between"], [1, "mb-0", "text-info"], [1, "col-lg-3", "col-12"], [1, "more-actions", "d-flex", "flex-column", "justify-content-around", "h-100", "bg-muted", "text-center", "text-primary", 3, "click"], [1, "mb-0"], ["ticketHistoryModal", ""], ["callbackModal", ""], [1, "col-3", "col-lg-2", "text-center"], ["type", "checkbox", "id", "selectTicket", "name", "selectTicket", 1, "ticket-list-item-check-box", 3, "checked", "change"], [1, "font-weight-bold"], [1, "col-3", "col-lg-2", "text-center", "bg-dark", "call-back-button", 3, "click"], [1, "icon-backward-7", "ticket-list-item-icon"], [1, "ticket-list-item-icon-text"], [1, "col-3", "col-lg-2", "text-center", "bg-primary", "d-flex", "justify-content-center", "align-items-center"], [1, "icon-credit-card", "ticket-list-item-icon-no-text"], [1, "col-3", "col-lg-2", "text-center", "bg-primary"], [1, "icon-ticket", "ticket-list-item-icon"], [1, "ticket-status", "font-weight-bold"], [1, "text-primary"], [1, "ticket-status"], [1, "text-primary", "font-weight-bold"], [1, "modal-header", "ticket-log-modal-header"], ["id", "modal-basic-title", 1, "modal-title", "ticket-log-modal-title"], ["type", "button", "aria-label", "Close modal", 1, "icon-cancel-circle", "close", "ticket-log-close-icon", 3, "click"], [1, "modal-body"], [3, "ticket"], [1, "text-center", "mb-5"], [1, "ticket-transfer-call-back-button-div"], [1, "ticket-transfer-confirm-callback-button", "d-block", 3, "disabled", "click"], [1, "btn-cancel-transfer", "d-block", "text-primary", 3, "disabled", "click"], [3, "size"]], template: function TicketListItemComponent_Template(rf, ctx) { if (rf & 1) {
        const _r24 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, TicketListItemComponent_div_2_Template, 5, 4, "div", 2);
        ɵngcc0.ɵɵtemplate(3, TicketListItemComponent_div_3_Template, 5, 3, "div", 3);
        ɵngcc0.ɵɵtemplate(4, TicketListItemComponent_div_4_Template, 2, 0, "div", 4);
        ɵngcc0.ɵɵtemplate(5, TicketListItemComponent_div_5_Template, 5, 3, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵelementStart(7, "div", 7);
        ɵngcc0.ɵɵelementStart(8, "div", 1);
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵelementStart(10, "p", 9);
        ɵngcc0.ɵɵtemplate(11, TicketListItemComponent_ng_container_11_Template, 3, 3, "ng-container", 10);
        ɵngcc0.ɵɵtemplate(12, TicketListItemComponent_ng_container_12_Template, 3, 3, "ng-container", 10);
        ɵngcc0.ɵɵelementStart(13, "span", 11);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "p", 12);
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵpipe(17, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 13);
        ɵngcc0.ɵɵtemplate(19, TicketListItemComponent_div_19_Template, 7, 7, "div", 10);
        ɵngcc0.ɵɵtemplate(20, TicketListItemComponent_div_20_Template, 7, 6, "div", 10);
        ɵngcc0.ɵɵelementStart(21, "div", 14);
        ɵngcc0.ɵɵelementStart(22, "div", 15);
        ɵngcc0.ɵɵelementStart(23, "p", 16);
        ɵngcc0.ɵɵtext(24);
        ɵngcc0.ɵɵpipe(25, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "p", 16);
        ɵngcc0.ɵɵtext(27);
        ɵngcc0.ɵɵpipe(28, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "p", 16);
        ɵngcc0.ɵɵtext(30);
        ɵngcc0.ɵɵpipe(31, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "div", 17);
        ɵngcc0.ɵɵelementStart(33, "div", 18);
        ɵngcc0.ɵɵlistener("click", function TicketListItemComponent_Template_div_click_33_listener() { ɵngcc0.ɵɵrestoreView(_r24); const _r8 = ɵngcc0.ɵɵreference(38); return ctx.open(_r8); });
        ɵngcc0.ɵɵelementStart(34, "p", 19);
        ɵngcc0.ɵɵtext(35);
        ɵngcc0.ɵɵpipe(36, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(37, TicketListItemComponent_ng_template_37_Template, 7, 4, "ng-template", null, 20, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(39, TicketListItemComponent_ng_template_39_Template, 14, 11, "ng-template", null, 21, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ticket.Flag === ctx.ticketFlag.ACTIVE && ctx.transferWindowOpen);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ticket.Flag !== ctx.ticketFlag.ACTIVE && ctx.transferWindowOpen);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ticket.Flag === ctx.ticketFlag.ACTIVE && !ctx.transferWindowOpen);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ticket.Flag !== ctx.ticketFlag.ACTIVE && !ctx.transferWindowOpen);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ticket.MediaType === 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ticket.MediaType === 1);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.ticket.ACN);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate2(" ", ɵngcc0.ɵɵpipeBind1(17, 18, "cl.ticket.list.item.area"), ": ", ctx.ticket.Area, " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ticket.Flag !== ctx.ticketFlag.ACTIVE && ctx.ticketFlag.TRANSFERRED === ctx.checkFlag(ctx.ticket.Flag, ctx.ticketFlag.TRANSFERRED));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ticket.Flag === ctx.ticketFlag.ACTIVE);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate2("", ɵngcc0.ɵɵpipeBind1(25, 20, "cl.ticket.list.item.table.section"), ": ", ctx.ticket.Stand, "");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate2("", ɵngcc0.ɵɵpipeBind1(28, 22, "cl.ticket.list.item.table.row"), ": ", ctx.ticket.Row, "");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate2("", ɵngcc0.ɵɵpipeBind1(31, 24, "cl.ticket.list.item.table.seat"), ": ", ctx.ticket.Seat, "");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(36, 26, "cl.ticket.list.item.ticket.history.expand.text"));
    } }, directives: function () { return [ɵngcc4.NgIf, TicketTransferLogComponent, ɵngcc5.GameBannerComponent, ɵngcc6.SelectedTicketsTableComponent, ɵngcc7.ErrorsComponent, ɵngcc8.LoadingComponent]; }, pipes: function () { return [ɵngcc9.TranslatePipe]; }, styles: [""] });
TicketListItemComponent.ctorParameters = () => [
    { type: NgbModal },
    { type: TicketService },
    { type: Router },
    { type: ErrorStateService }
];
TicketListItemComponent.propDecorators = {
    ticket: [{ type: Input }],
    transferWindowExists: [{ type: Input }],
    transferWindowOpen: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TicketListItemComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-ticket-list-item',
                template: "<div class=\"card mb-4\">\r\n  <div class=\"row\">\r\n    <div *ngIf=\"ticket.Flag === ticketFlag.ACTIVE && transferWindowOpen\" class=\"col-3 col-lg-2 text-center\">\r\n      <input\r\n        class=\"ticket-list-item-check-box\"\r\n        type=\"checkbox\"\r\n        id=\"selectTicket\"\r\n        name=\"selectTicket\"\r\n        (change)=\"toggleSelectTicket(ticket.Id)\"\r\n        [checked]=\"ticket.selected\"\r\n      />\r\n      <div class=\"font-weight-bold\">{{ 'cl.ticket.list.item.select.ticket' | translate }}</div>\r\n    </div>\r\n    <div\r\n      *ngIf=\"ticket.Flag !== ticketFlag.ACTIVE && transferWindowOpen\"\r\n      class=\"col-3 col-lg-2 text-center bg-dark call-back-button\"\r\n      (click)=\"open(callbackModal)\"\r\n    >\r\n      <div class=\"icon-backward-7 ticket-list-item-icon\"></div>\r\n      <div class=\"ticket-list-item-icon-text\">{{ 'cl.ticket.list.item.call.back' | translate }}</div>\r\n    </div>\r\n    <div\r\n      *ngIf=\"ticket.Flag === ticketFlag.ACTIVE && !transferWindowOpen\"\r\n      class=\"col-3 col-lg-2 text-center bg-primary d-flex justify-content-center align-items-center\"\r\n    >\r\n      <div class=\"icon-credit-card ticket-list-item-icon-no-text\"></div>\r\n    </div>\r\n    <div *ngIf=\"ticket.Flag !== ticketFlag.ACTIVE && !transferWindowOpen\" class=\"col-3 col-lg-2 text-center bg-primary\">\r\n      <div class=\"icon-ticket ticket-list-item-icon\"></div>\r\n      <div class=\"ticket-list-item-icon-text\">{{ 'cl.ticket.list.item.transferred' | translate }}</div>\r\n    </div>\r\n    <!-- Ticket Information -->\r\n    <div class=\"col-9 col-lg-7\">\r\n      <div class=\"ticket-list-item\">\r\n        <div class=\"row\">\r\n          <div class=\"col-lg-4 col-12 card-number-div\">\r\n            <p class=\"ticket-status font-weight-bold justify-content-around\">\r\n              <ng-container *ngIf=\"ticket.MediaType === 0\">{{ 'cl.ticket.list.item.card.no' | translate }}:</ng-container>\r\n              <ng-container *ngIf=\"ticket.MediaType === 1\">{{ 'cl.ticket.list.item.ticket.no' | translate }}:</ng-container>\r\n              <span class=\"text-primary ml-1\">{{ ticket.ACN }}</span>\r\n            </p>\r\n            <p class=\"d-none d-lg-block ticket-area mb-0 text-info\">\r\n              {{ 'cl.ticket.list.item.area' | translate }}: {{ ticket.Area }}\r\n            </p>\r\n          </div>\r\n          <div class=\"col-lg-8 col-12 justify-content-around status-div\">\r\n            <div\r\n              *ngIf=\"\r\n                ticket.Flag !== ticketFlag.ACTIVE && ticketFlag.TRANSFERRED === checkFlag(ticket.Flag, ticketFlag.TRANSFERRED)\r\n              \"\r\n            >\r\n              <p class=\"ticket-status font-weight-bold\">\r\n                {{ 'cl.ticket.list.item.status' | translate }}:<span class=\"text-primary\">\r\n                  {{ 'cl.ticket.list.item.transferred.to' | translate }} - {{ ticket.TransfereeEmailAddress }}\r\n                </span>\r\n              </p>\r\n            </div>\r\n            <div *ngIf=\"ticket.Flag === ticketFlag.ACTIVE\">\r\n              <p class=\"ticket-status\">\r\n                {{ 'cl.ticket.list.item.status' | translate }}:\r\n                <span class=\"text-primary font-weight-bold\">{{ 'cl.ticket.list.item.available' | translate }}</span>\r\n              </p>\r\n            </div>\r\n            <div class=\"pl-0 col-8 col-lg-12\">\r\n              <div class=\"seat-details d-flex justify-content-between\">\r\n                <p class=\"mb-0 text-info\">{{ 'cl.ticket.list.item.table.section' | translate }}: {{ ticket.Stand }}</p>\r\n                <p class=\"mb-0 text-info\">{{ 'cl.ticket.list.item.table.row' | translate }}: {{ ticket.Row }}</p>\r\n                <p class=\"mb-0 text-info\">{{ 'cl.ticket.list.item.table.seat' | translate }}: {{ ticket.Seat }}</p>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <!-- Toggle Ticket Transfer History -->\r\n    <div class=\"col-lg-3 col-12\">\r\n      <div\r\n        class=\"more-actions d-flex flex-column justify-content-around h-100 bg-muted text-center text-primary\"\r\n        (click)=\"open(ticketHistoryModal)\"\r\n      >\r\n        <p class=\"mb-0\">{{ 'cl.ticket.list.item.ticket.history.expand.text' | translate }}</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!-- Modal -->\r\n<ng-template #ticketHistoryModal let-modal>\r\n  <div class=\"modal-header ticket-log-modal-header\">\r\n    <h4 class=\"modal-title ticket-log-modal-title\" id=\"modal-basic-title\">{{ 'cl.ticket.log.modal.title' | translate }}</h4>\r\n    <button\r\n      type=\"button\"\r\n      class=\"icon-cancel-circle close ticket-log-close-icon\"\r\n      aria-label=\"Close modal\"\r\n      (click)=\"modal.dismiss('Cross click')\"\r\n    ></button>\r\n  </div>\r\n  <div class=\"modal-body\">\r\n    <fgbcl-ticket-transfer-log [ticket]=\"ticket\"></fgbcl-ticket-transfer-log>\r\n  </div>\r\n</ng-template>\r\n<ng-template #callbackModal let-modal>\r\n  <fgbcl-game-banner></fgbcl-game-banner>\r\n  <div class=\"modal-body\">\r\n    <div class=\"text-center mb-5\">\r\n      {{ 'cl.ticket.transfer.callback.text' | translate }}\r\n    </div>\r\n\r\n    <fgbcl-selected-tickets-table [ticket]=\"ticket\"></fgbcl-selected-tickets-table>\r\n    <fgbcl-errors></fgbcl-errors>\r\n\r\n    <div class=\"ticket-transfer-call-back-button-div\">\r\n      <button (click)=\"callbackTicket()\" class=\"ticket-transfer-confirm-callback-button d-block\" [disabled]=\"loading\">\r\n        <span *ngIf=\"!loading\">{{ 'cl.ticket.transfer.callback.confirm.button' | translate }}</span>\r\n        <span *ngIf=\"loading\"><fgbcl-loading [size]=\"'small'\"></fgbcl-loading></span>\r\n      </button>\r\n\r\n      <button class=\"btn-cancel-transfer d-block text-primary\" (click)=\"modal.dismiss('Cross click')\" [disabled]=\"loading\">\r\n        {{ 'cl.ticket.transfer.callback.cancel.button' | translate }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.NgbModal }, { type: ɵngcc2.TicketService }, { type: ɵngcc3.Router }, { type: ɵngcc2.ErrorStateService }]; }, { ticket: [{
            type: Input
        }], transferWindowExists: [{
            type: Input
        }], transferWindowOpen: [{
            type: Input
        }] }); })();

const moment = _moment;
class TicketTransferLogComponent {
    constructor(ticketSerivce) {
        this.ticketSerivce = ticketSerivce;
        this.ticketTransactionType = TicketTransactionType;
    }
    ngOnInit() {
        this.ticketLog$ = this.ticketSerivce.fetchTransferHistory(this.ticket.MemberId, this.ticket.ACN, this.ticket.GameNumber).pipe(tap(logItems => logItems.map(item => (item.Date = moment
            .utc(item.Date)
            .local()
            .toDate()))));
    }
}
TicketTransferLogComponent.ɵfac = function TicketTransferLogComponent_Factory(t) { return new (t || TicketTransferLogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.TicketService)); };
TicketTransferLogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TicketTransferLogComponent, selectors: [["fgbcl-ticket-transfer-log"]], inputs: { ticket: "ticket" }, decls: 33, vars: 19, consts: [[1, "row", "ticket-log-table-row"], [1, "col-lg-3", "col-6", "font-weight-bold"], [1, "text-primary"], [4, "ngIf"], ["noLogItems", ""], [4, "ngIf", "ngIfElse"], [1, "d-none", "d-lg-block"], [1, "table", "ticket-table"], ["scope", "col"], ["class", "ticket-log-list-row", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], [1, "ticket-log-list-row"], ["notAttended", ""], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [1, "mobile-log", "row", "d-lg-none", "bg-muted", "p-4"], [1, "col-12"], [1, "title"], [1, "col-8"], [1, "col-4"], [1, "no-items", "text-center", "p-4"]], template: function TicketTransferLogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "p");
        ɵngcc0.ɵɵelementStart(3, "span");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵpipe(5, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "span", 2);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 1);
        ɵngcc0.ɵɵelementStart(9, "p");
        ɵngcc0.ɵɵelementStart(10, "span");
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "span", 2);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 1);
        ɵngcc0.ɵɵelementStart(16, "p");
        ɵngcc0.ɵɵelementStart(17, "span");
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵpipe(19, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "span", 2);
        ɵngcc0.ɵɵtext(21);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "div", 1);
        ɵngcc0.ɵɵelementStart(23, "p");
        ɵngcc0.ɵɵelementStart(24, "span");
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵpipe(26, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(27, "span", 2);
        ɵngcc0.ɵɵtext(28);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(29, TicketTransferLogComponent_ng_container_29_Template, 2, 2, "ng-container", 3);
        ɵngcc0.ɵɵpipe(30, "async");
        ɵngcc0.ɵɵtemplate(31, TicketTransferLogComponent_ng_template_31_Template, 2, 0, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(5, 9, "cl.ticket.transfer.log.area"), ": ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.ticket.Area);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(12, 11, "cl.ticket.transfer.log.section"), ": ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.ticket.Stand);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(19, 13, "cl.ticket.transfer.log.row"), ": ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.ticket.Row);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(26, 15, "cl.ticket.transfer.log.seat"), ": ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.ticket.Seat);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(30, 17, ctx.ticketLog$));
    } }, directives: [ɵngcc4.NgIf, ɵngcc4.NgForOf, ɵngcc4.NgSwitch, ɵngcc4.NgSwitchCase, ɵngcc4.NgSwitchDefault], pipes: [ɵngcc9.TranslatePipe, ɵngcc4.AsyncPipe, ɵngcc4.DatePipe], styles: [".mobile-log[_ngcontent-%COMP%]{margin:9px 0;border-radius:5px}.title[_ngcontent-%COMP%]{font-size:12px}@media (max-width:992px){.row[_ngcontent-%COMP%]{margin-right:0;margin-left:0}}.no-items[_ngcontent-%COMP%]{font-size:12px}"] });
TicketTransferLogComponent.ctorParameters = () => [
    { type: TicketService }
];
TicketTransferLogComponent.propDecorators = {
    ticket: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TicketTransferLogComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-ticket-transfer-log',
                template: "<div class=\"row ticket-log-table-row\">\r\n  <div class=\"col-lg-3 col-6 font-weight-bold\">\r\n    <p>\r\n      <span>{{ 'cl.ticket.transfer.log.area' | translate }}: </span><span class=\"text-primary\">{{ ticket.Area }}</span>\r\n    </p>\r\n  </div>\r\n  <div class=\"col-lg-3 col-6 font-weight-bold\">\r\n    <p>\r\n      <span>{{ 'cl.ticket.transfer.log.section' | translate }}: </span><span class=\"text-primary\">{{ ticket.Stand }}</span>\r\n    </p>\r\n  </div>\r\n  <div class=\"col-lg-3 col-6 font-weight-bold\">\r\n    <p>\r\n      <span>{{ 'cl.ticket.transfer.log.row' | translate }}: </span><span class=\"text-primary\">{{ ticket.Row }}</span>\r\n    </p>\r\n  </div>\r\n  <div class=\"col-lg-3 col-6 font-weight-bold\">\r\n    <p>\r\n      <span>{{ 'cl.ticket.transfer.log.seat' | translate }}: </span>\r\n      <span class=\"text-primary\">{{ ticket.Seat }}</span>\r\n    </p>\r\n  </div>\r\n</div>\r\n<ng-container *ngIf=\"ticketLog$ | async as ticketLog\">\r\n  <ng-container *ngIf=\"ticketLog.length > 0; else noLogItems\">\r\n    <div class=\"d-none d-lg-block\">\r\n      <table class=\"table ticket-table\">\r\n        <thead>\r\n          <tr>\r\n            <th scope=\"col\">{{ 'cl.ticket.transfer.log.recipient' | translate }}</th>\r\n            <th scope=\"col\">{{ 'cl.ticket.transfer.log.date.and.time' | translate }}</th>\r\n            <th scope=\"col\">{{ 'cl.ticket.transfer.log.status' | translate }}</th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <tr class=\"ticket-log-list-row\" *ngFor=\"let log of ticketLog\">\r\n            <ng-container *ngIf=\"log.ATTENDANCE; else notAttended\">\r\n              <td>{{ log.EmailAddress }}</td>\r\n              <td>{{ log.ATTENDANCE | date }}</td>\r\n              <td class=\"text-primary\">{{ 'cl.ticket.transfer.log.attended' | translate }}</td>\r\n            </ng-container>\r\n            <ng-template #notAttended>\r\n              <ng-container [ngSwitch]=\"log.TransactionTypeId\">\r\n                <td *ngSwitchCase=\"14\">{{ log.FullName }} ({{ log.EmailAddress }})</td>\r\n                <td *ngSwitchDefault>{{ log.TransfereeFullName }} ({{ log.TransfereeEmailAddress }})</td>\r\n              </ng-container>\r\n              <td>{{ log.Date | date: 'd MMM y |  h:mm a' }}</td>\r\n              <td>{{ ticketTransactionType[log.TransactionTypeId] }}</td>\r\n            </ng-template>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>\r\n    <ng-container *ngFor=\"let log of ticketLog\">\r\n      <div class=\"mobile-log row d-lg-none bg-muted p-4\">\r\n        <div class=\"col-12\">\r\n          <span class=\"title\">{{ 'cl.mobile.ticket.transfer.log.recipient' | translate }}</span>\r\n          <p>{{ log.FullName }} ({{ log.EmailAddress }})</p>\r\n        </div>\r\n        <div class=\"col-8\">\r\n          <span class=\"title\">{{ 'cl.mobile.ticket.transfer.log.date.and.time' | translate }}</span>\r\n          <p>{{ log.Date | date: 'd MMM y -  h:mm a' }}</p>\r\n        </div>\r\n        <div class=\"col-4\">\r\n          <span class=\"title\">{{ 'cl.mobile.ticket.transfer.log.status' | translate }}</span>\r\n          <p>{{ ticketTransactionType[log.TransactionTypeId] }}</p>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  </ng-container>\r\n</ng-container>\r\n<ng-template #noLogItems>\r\n  <div class=\"no-items text-center p-4\">No Items Found</div>\r\n</ng-template>\r\n",
                styles: [".mobile-log{margin:9px 0;border-radius:5px}.title{font-size:12px}@media (max-width:992px){.row{margin-right:0;margin-left:0}}.no-items{font-size:12px}"]
            }]
    }], function () { return [{ type: ɵngcc2.TicketService }]; }, { ticket: [{
            type: Input
        }] }); })();

class TicketListItemModule {
}
TicketListItemModule.ɵfac = function TicketListItemModule_Factory(t) { return new (t || TicketListItemModule)(); };
TicketListItemModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TicketListItemModule });
TicketListItemModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
            GameBannerModule,
            SelectedTicketsTableModule,
            ErrorsModule,
            LoadingModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TicketListItemModule, { declarations: function () { return [TicketListItemComponent, TicketTransferLogComponent]; }, imports: function () { return [CommonModule, ɵngcc9.TranslateModule, GameBannerModule,
        SelectedTicketsTableModule,
        ErrorsModule,
        LoadingModule]; }, exports: function () { return [TicketListItemComponent, TicketTransferLogComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TicketListItemModule, [{
        type: NgModule,
        args: [{
                declarations: [TicketListItemComponent, TicketTransferLogComponent],
                imports: [
                    CommonModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                    GameBannerModule,
                    SelectedTicketsTableModule,
                    ErrorsModule,
                    LoadingModule,
                ],
                exports: [TicketListItemComponent, TicketTransferLogComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TicketListItemComponent, TicketListItemModule, TicketTransferLogComponent };

//# sourceMappingURL=fgb-portal-component-library-src-lib-tickettransfer-ticket-list-item.js.map